export const summaryItems = [
  {
    label: 'Customer',
    value: 30,
  },
  {
    label: 'Staff',
    value: 50,
  },
  {
    label: 'Business Contact',
    value: '3.5k',
  },
]

export const homeTabItems = [
  { label: 'Users', value: 'users' },
  { label: 'Branch', value: 'branch' },
  { label: 'Lead Transfer', value: 'lead-transfer' },
  { label: 'Imported Leads', value: 'imported-leads' },
  { label: 'Auto Exclusions', value: 'auto-exclusions' },
  { label: 'Models', value: 'models' },
  { label: 'Substitutes', value: 'substitutes' },
  { label: 'Average List Price', value: 'price-lists' },
  { label: 'Bookings', value: 'bookings' },
  { label: 'Retails', value: 'retails' },
  { label: 'Offers', value: 'offers' },
  { label: 'Customers', value: 'customers' },
  { label: 'Inventory - New', value: 'inventory' },
  { label: 'Business Agents', value: 'business-agents' },
  { label: 'Configuration', value: 'configuration' },
  { label: 'Funnel Setup', value: 'funnel-setup' },
]

export const targetTypeOptions = [
  { value: 'booking', label: 'Booking' },
  { value: 'retail', label: 'Retail' },
]

export const conversionRatioStages = [
  {
    id: '1',
    stage: 'Leads Added to Leads Dropped',
    isAutoComputed: false,
  },
  {
    id: '2',
    stage: 'Leads Added to Verified Leads',
    isAutoComputed: false,
  },
  {
    id: '3',
    stage: 'Verified Leads to Leads Committed',
    isAutoComputed: false,
  },
  {
    id: '4',
    stage: 'Committed to Active Bookings',
    isAutoComputed: false,
  },
  {
    id: '5',
    stage: 'Active Bookings to Retails',
    isAutoComputed: false,
  },
  {
    id: '6',
    stage: 'Leads Added to Bookings (Auto - Computed)',
    isAutoComputed: true,
  },
  {
    id: '7',
    stage: 'Verified Leads to Bookings (Auto-Computed)',
    isAutoComputed: true,
  },
]

export const TIMEZONE_MAP: Record<string, string[]> = {
  IN: ['Asia/Kolkata'], // India
  US: [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Phoenix',
    'America/Anchorage',
    'Pacific/Honolulu',
  ],
  GB: ['Europe/London'], // United Kingdom
  CA: [
    'America/Toronto',
    'America/Vancouver',
    'America/Edmonton',
    'America/Winnipeg',
    'America/Halifax',
    'America/St_Johns',
  ],
  AU: [
    'Australia/Sydney',
    'Australia/Melbourne',
    'Australia/Brisbane',
    'Australia/Perth',
    'Australia/Adelaide',
    'Australia/Darwin',
  ],
  JP: ['Asia/Tokyo'], // Japan
  CN: ['Asia/Shanghai'], // China
  DE: ['Europe/Berlin'], // Germany
  FR: ['Europe/Paris'], // France
  IT: ['Europe/Rome'], // Italy
  ES: ['Europe/Madrid'], // Spain
  BR: ['America/Sao_Paulo'], // Brazil
  MX: ['America/Mexico_City'], // Mexico
  RU: ['Europe/Moscow'], // Russia
  ZA: ['Africa/Johannesburg'], // South Africa
  AE: ['Asia/Dubai'], // UAE
  SG: ['Asia/Singapore'], // Singapore
  MY: ['Asia/Kuala_Lumpur'], // Malaysia
  TH: ['Asia/Bangkok'], // Thailand
  ID: ['Asia/Jakarta'], // Indonesia
  PH: ['Asia/Manila'], // Philippines
  NZ: ['Pacific/Auckland'], // New Zealand
}

export const salespersonOptions = [
  { value: 'Krishna K.', label: 'Krishna K.' },
  { value: 'Karan T.', label: 'Karan T.' },
  { value: 'Rajesh K.', label: 'Rajesh K.' },
  { value: 'Anil R.', label: 'Anil R.' },
  { value: 'Deepak M.', label: 'Deepak M.' },
  { value: 'Suresh P.', label: 'Suresh P.' },
  { value: 'Vijay S.', label: 'Vijay S.' },
  { value: 'Ravi K.', label: 'Ravi K.' },
  { value: 'Kunal J.', label: 'Kunal J.' },
  { value: 'Nisha R.', label: 'Nisha R.' },
  { value: 'Ravi S.', label: 'Ravi S.' },
  { value: 'Priya V.', label: 'Priya V.' },
  { value: 'Samir D.', label: 'Samir D.' },
  { value: 'Riya A.', label: 'Riya A.' },
  { value: 'Vikram O.', label: 'Vikram O.' },
]
